import { useQuery } from '@tanstack/react-query';
import { api } from '../../libs/axios';
import { MetaPagination, Pedido } from '../../utils/interfaces';

export interface RelatorioFilter {
  status?: string;
  ordem_trabalho?: string;
  usuario?: string;
  data_inicial?: string;
  data_final?: string;
  agencia?: string;
}

export interface useRelatorioProps {
  page: number;
  filter?: RelatorioFilter;
}

interface GetRelatorioResponse {
  pedidos: Pedido[];
  meta: MetaPagination;
}
async function getRelatorio({ page, filter }: useRelatorioProps): Promise<GetRelatorioResponse> {
  const response = await api
    .get('pedido', {
      params: {
        page,
        ...filter,
      },
    })
    .then((res) => res.data);

  const pedidos: Pedido[] = response.data;

  const meta = {
    current_page: response.meta.current_page,
    last_page: response.meta.last_page,
    per_page: response.meta.per_page,
    to: response.meta.to,
    total: response.meta.total,
  };

  return {
    pedidos,
    meta
  };
}

export function useRelatorios({ page, filter }: useRelatorioProps) {
  return useQuery({
    queryKey: ['pedidos-lista', { page, filter }],
    queryFn: () => getRelatorio({ page, filter }),
    staleTime: 1,
    gcTime: 1,
    retry: false,
    refetchOnWindowFocus: false, // Only refetch when the window is not in focus
  });
}
